import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EComItemSettingsDialogComponent } from './ecom-item-settings-dialog/ecom-item-settings-dialog.component';
import { AtlasSharedModule } from '../shared/module/atlas-shared.module';
import { ThirdPartySharedModule } from '../shared/module/third-party-shared.module';
import { EcomRoutingModule } from './ecommerce-routing.module';
import { EComItemEditGeneralComponent } from './ecom-item-edit-general/ecom-item-edit-general.component';
import { EComListComponent } from './ecom-list/ecom-list.component';
import { EComItemEditCustomFieldsComponent } from './ecom-item-edit-custom-fields/ecom-item-edit-custom-fields.component';
import { EComItemEditDownloadableWebContentComponent } from './ecom-item-edit-downloadable-web-content/ecom-item-edit-downloadable-web-content.component';
import { EComItemEditImagesComponent } from './ecom-item-edit-images/ecom-item-edit-images.component';
import { EComItemEditOptionsComponent } from './ecom-item-edit-options/ecom-item-edit-options.component';
import { EComItemEditRestrictionsComponent } from './ecom-item-edit-restrictions/ecom-item-edit-restrictions.component';
import { EComItemEditSearchKeywordsComponent } from './ecom-item-edit-search-keywords/ecom-item-edit-search-keywords.component';
import { EComItemEditShippingComponent } from './ecom-item-edit-shipping/ecom-item-edit-shipping.component';
import { EComWebContentEditComponent } from './ecom-web-content-edit/ecom-web-content-edit.component';
import { NgxMaskModule } from 'ngx-mask';
import { EComItemEditAffCodesComponent } from './ecom-item-edit-affcodes/ecom-item-edit-affcodes.component';
import { EcomItemEditOptionTypesComponent } from './ecom-item-edit-option-types/ecom-item-edit-option-types.component';

@NgModule({
  declarations: [
    EComItemSettingsDialogComponent,
    EComItemEditImagesComponent,
    EComItemEditOptionsComponent,
    EComItemEditShippingComponent,
    EComWebContentEditComponent,
    EComItemEditRestrictionsComponent,
    EComItemEditSearchKeywordsComponent,
    EComItemEditDownloadableWebContentComponent,
    EComItemEditGeneralComponent,
    EComItemEditCustomFieldsComponent,
    EComListComponent,
    EComItemEditAffCodesComponent,
    EcomItemEditOptionTypesComponent,
  ],
  imports: [CommonModule, EcomRoutingModule, AtlasSharedModule, ThirdPartySharedModule, NgxMaskModule.forChild()],
})
export class EcomModule {}
